import { BaseField } from './BaseField';

const imgTerraceAreaIcon = "/assets/garden-area-icon.svg";

export class TerraceField extends BaseField {
  constructor() {
    super({
      key: 'terrace',
      icon: imgTerraceAreaIcon,
      defaultLabel: 'Pow. tarasu'
    });
  }

  renderForList(property) {
    const terrace = property.specifications.features.terrace;

    if (terrace?.hasGastroPotential) {
      return { label: 'Taras', value: 'Możliwy ogródek gastronomiczny' };
    }

    // New logic: handle multiple terraces from details array
    if (terrace?.details && Array.isArray(terrace.details) && terrace.details.length > 0) {
      const count = terrace.details.length;
      const areas = terrace.details
        .map(t => `${parseFloat(t.area).toFixed(2).replace('.', ',')} m²`)
        .join(' + ');

      if (count === 1) {
        return { label: 'Taras', value: areas };
      }
      // Polish grammar: 2-4 = "tarasy", 5+ = "tarasów"
      const tarasLabel = count >= 2 && count <= 4 ? 'tarasy' : 'tarasów';
      return { label: 'Taras', value: `${count} ${tarasLabel}: ${areas}` };
    }

    // Fallback to old logic (for backward compatibility)
    if (terrace?.available && terrace.area > 0) {
      return { label: 'Taras', value: `${terrace.area} m²` };
    }
    return { label: 'Taras', value: 'brak' };
  }

  renderForCard(property) {
    return this.renderForList(property);
  }
}
